import { getCoreUtils, StringOnlyOf } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kJsonObject } from "../../../Admin/kReusableCoreTS/kJsonObject";
import { AppLiveRules } from "./AppLiveRules";
import { AppIcons } from "./AppIcons";
import { WhatsAppAddress } from "../../Shared/WhatsAppAddress";

export class AppChatListPage {
    public Ok: boolean = false;
    public Ids: string[] = [];
    public Cursor: string = "";
    public Complete: boolean = false;
    public Why: string = "Chat settings could not be checked. Choose the view again to retry.";
}

/** Read-only list selection; only confirmed native archive state or acknowledged local stars qualify. */
export class AppChatListRules {
    /** Settings scope includes local group favourites; native settings retain their direct-chat guards. */
    public static IdOk = (Id: string): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (AppLiveRules.ChatIdOk(Id) === true) { return true; }
            if (WhatsAppAddress.IsJid(Id) === false || WhatsAppAddress.IsGroup(Id) === false) { return false; }
            const Parts: string[] = Id.substring(0, Id.indexOf("@")).split("-");
            if (Parts[0].length < 5 || Parts[0].length > 20) { return false; }
            if (Parts.length === 2 && (Parts[1].length < 1 || Parts[1].length > 20)) { return false; }
            return true;
        }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatListRules.IdOk"); return false; }
    };
    public static readonly Attr: string = "data-wac-chatview";
    public static readonly Id: string = "wac-chatviews";
    public static readonly NoteId: string = "wac-chatviews-note";
    public static readonly Views: string[] = ["all", "starred", "archived"];

    public static Switch = (View: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Out: string[] = ["<div class=\"chatviews\" id=\"" + AppChatListRules.Id + "\" role=\"group\" aria-label=\"Which chats to show\">"];
            for (const One of AppChatListRules.Views) {
                let Word: string = "All"; let Icon: string = "";
                if (One === "starred") { Word = "Starred"; Icon = AppIcons.Svg(AppIcons.Star, 14); }
                if (One === "archived") { Word = "Archived"; Icon = AppIcons.Svg(AppIcons.Archive, 14); }
                Out.push("<button type=\"button\" class=\"btn ghost sm\" " + AppChatListRules.Attr + "=\"" + One
                    + "\" aria-pressed=\"" + String(One === View) + "\">" + Icon + Word + "</button>");
            }
            Out.push("</div><p class=\"small muted\" id=\"" + AppChatListRules.NoteId + "\" role=\"status\" hidden></p>");
            return Out.join("");
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatListRules.Switch"); return ""; }
    };

    public static Parse = (Status: number, Text: string, View: string): AppChatListPage => {
        const Out: AppChatListPage = new AppChatListPage();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            const Doc: Record<string, unknown> | null = kJsonObject.ObjectOfJson(Text);
            if (Doc === null || Status < 200 || Status >= 300 || Doc.ok !== true) {
                if (Doc !== null && typeof Doc.why === "string" && Doc.why.length > 0) { Out.Why = Doc.why; }
                return Out;
            }
            if (Array.isArray(Doc.states) === false || (Doc.states as unknown[]).length > 1000 || typeof Doc.complete !== "boolean") { return Out; }
            if (Doc.nextCursor !== null && (typeof Doc.nextCursor !== "string" || Doc.nextCursor.length === 0 || Doc.nextCursor.length > 4096)) { return Out; }
            if (Doc.complete === true && Doc.nextCursor !== null) { return Out; }
            for (const Raw of Doc.states as unknown[]) {
                if (Raw === null || typeof Raw !== "object" || Array.isArray(Raw) === true) { return new AppChatListPage(); }
                const One: Record<string, unknown> = Raw as Record<string, unknown>;
                const Id: string = StringOnlyOf(One.chatId);
                if (AppChatListRules.IdOk(Id) === false) { return new AppChatListPage(); }
                let Match: boolean = View === "all";
                if (View === "archived") { Match = AppLiveRules.ChatIdOk(Id) === true && One.known === true && One.archived === true; }
                if (View === "starred") { Match = One.starredKnown === true && One.starred === true; }
                if (Match === true && Out.Ids.indexOf(Id) < 0) { Out.Ids.push(Id); }
            }
            Out.Ok = true; Out.Complete = Doc.complete; Out.Cursor = StringOnlyOf(Doc.nextCursor); Out.Why = "";
            return Out;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatListRules.Parse"); return Out; }
    };
}
